<a
  routerLink="{{ target }}"
  routerLinkActive="active"
  ariaCurrentWhenActive="page"
>
  <ng-content></ng-content>
</a>
